module.exports = __webpack_public_path__ + "img/correcao-estatica-tomografia-4.e1aa1129.png";